export function keys<T>(obj: T): (keyof T)[] {
  // tslint:disable-next-line:no-any
  return Object.keys(obj) as any;
}
